// extracted by mini-css-extract-plugin
export var aiStarIcon = "_jp-2";
export var container = "_jp-4";
export var dismissButton = "_jp-3";
export var hasPaddingBottom = "_jp-6";
export var last = "_jp-e";
export var scrollbarThumb = "_jp-c";
export var scrollbarTrack = "_jp-b";
export var selected = "_jp-9";
export var spin = "_jp-1";
export var spinning = "_jp-0";
export var suggestionItem = "_jp-d";
export var suggestionsPanel = "_jp-5";
export var tonePill = "_jp-8";
export var tonesContainer = "_jp-7";
export var unselected = "_jp-a";